import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom"
import { Nav } from "./components/common/Nav"
import { Home } from "./components/pages/Home"
import { Privacy } from "./components/pages/Privacy"
import { Cookies } from "./components/pages/Cookies"
import { NotFound } from "./components/pages/NotFound"
import { Footer } from "./components/common/Footer"
import { ScrollToTop } from "./components/common/ScrollToTop"
import { CookiesNotification } from "./components/common/CookiesNotification"
import { ParallaxProvider } from "react-scroll-parallax"
import "./App.css"

const RoutesWithTransition = () => {
  const location = useLocation()

  return (
    <Routes location={location}>
      <Route path='/' element={<Home />} />
      <Route path='/privacy' element={<Privacy />} />
      <Route path='/cookies' element={<Cookies />} />
      <Route path='*' element={<NotFound />} />
    </Routes>
  )
}

const App = () => {
  return (
    <div>
      <ParallaxProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Nav />
          <RoutesWithTransition />
          <Footer />
          <CookiesNotification />
        </BrowserRouter>
      </ParallaxProvider>
    </div>
  )
}

export default App
